<template>
  <a class="pc-back-link" :id="id" :data-id="dataId" @click="$emit('click')">
    <pc-icon
      name="pc-angle-left"
      size="12"
      class="pc-back-link-icon"
      :color="$colors.penChecksTeal"
    ></pc-icon>
    <span>{{ text }}</span>
  </a>
</template>

<script>
export default {
  components: {},

  props: {
    text: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: false,
    },
    dataId: {
      type: String,
      required: false,
      validator(value) {
        return !value || value.length == 32;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.pc-back-link {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  color: $penChecksTeal !important;
  text-decoration: none;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  line-height: 16.41px;
  text-align: left;

  .pc-back-link-icon {
    margin-right: 8px;
  }
}
</style>
